import { render, staticRenderFns } from "./indexWithoutTown.vue?vue&type=template&id=5e237bf0&scoped=true&"
import script from "./indexWithoutTown.vue?vue&type=script&lang=ts&"
export * from "./indexWithoutTown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e237bf0",
  null
  
)

export default component.exports